/** Shapes mirrored from the backend assistant service. */

export interface AssistantProductCard {
  id: string;
  title: string;
  price: string;
  currency: string;
  category: string;
  origin: string;
  location: string;
  image: string | null;
  path: string;
  sellerName: string;
  isVerifiedSeller: boolean;
}

export interface AssistantRequestCard {
  id: string;
  productName: string;
  category: string | null;
  origin: string;
  budget: string | null;
  path: string;
}

export interface AssistantNavAction {
  path: string;
  label: string;
  requiresAuth: boolean;
}

export type AssistantAttachment =
  | { type: "products"; items: AssistantProductCard[] }
  | { type: "requests"; items: AssistantRequestCard[] }
  | { type: "navigation"; actions: AssistantNavAction[] }
  | { type: "escalated"; reference: string };

/** Server-sent events emitted by POST /api/assistant/chat. */
export type AssistantStreamEvent =
  | { type: "session"; sessionId: string }
  | { type: "text"; delta: string }
  | { type: "tool"; label: string }
  | { type: "ui"; payload: AssistantAttachment }
  | { type: "done"; text: string }
  | { type: "error"; message: string };

export interface AssistantMessage {
  id: string;
  role: "user" | "assistant";
  text: string;
  attachments: AssistantAttachment[];
  /** Set on assistant messages that failed, so the bubble can render as an error. */
  isError?: boolean;
  createdAt: number;
}

export interface AssistantState {
  isOpen: boolean;
  /** True while the stored conversation is being replayed after a reload. */
  isRestoring: boolean;
  /** null until the status probe resolves; false hides the launcher entirely. */
  isEnabled: boolean | null;
  sessionId: string | null;
  messages: AssistantMessage[];
  isStreaming: boolean;
  /** Transient "Searching listings…" status while a tool runs. */
  toolStatus: string | null;
  /** Count of assistant replies arriving while the panel is closed. */
  unreadCount: number;
  /** Last user message, kept so a failed turn can be retried in one tap. */
  lastQuestion: string | null;
}

export const ASSISTANT_SESSION_STORAGE_KEY = "baoafrik.assistant.sessionId";
